export default __webpack_public_path__ + "static/latency3-fc05458decada54f78ac462eba9caaca.png";